import Vue from 'vue';

Vue.filter('formatRank', function (value) {
    if (value < 10) {
        return '0' + value;
    }

    return value;
});
